import TemplatingTextArea from './TemplatingTextArea';

export default TemplatingTextArea;
